export default "__VITE_ASSET__473496be__"